import classNames from 'classnames';
import * as React from 'react';

import css from './BooksNotes.module.scss';

interface Notes {
  title: string;
  description: string;
  caution?: string;
}

interface Props {
  notes: Notes[];
}

const BooksNotes = ({ notes }: Props) => {
  const classes = classNames(css.BooksNotes);

  return (
    <div className={classes}>
      {notes.map((note, index) => (
        <dl key={index} className={css.BooksNotes__Contents}>
          <dt className={css.BooksNotes__Title}>{note.title}</dt>
          <dd className={css.BooksNotes__Description}>
            {note.description}
            {note.caution && (
              <span className={css.BooksNotes__Caution}>{note.caution}</span>
            )}
          </dd>
        </dl>
      ))}
    </div>
  );
};

export default BooksNotes;
